import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const SectionHead = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin: 0 0 1rem 0;
`;

export const SectionTitle = styled.h2`
  font-family: 'Inter', sans-serif;
  font-size: 1.25rem;
  font-weight: 700;
  letter-spacing: -0.015em;
  color: var(--text-primary);
  margin: 0;
`;

export const SectionHint = styled.span`
  font-size: 0.8125rem;
  color: var(--text-muted);
`;

/* ---------- To Do banners ---------- */

export const TodoStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.875rem;
  margin-bottom: 2rem;
`;

export const TodoBanner = styled(Link)`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.125rem 1.5rem;
  background: linear-gradient(135deg, rgba(168, 146, 84, 0.14) 0%, rgba(184, 149, 106, 0.08) 100%);
  border: 2px solid var(--primary-color);
  border-radius: 12px;
  color: inherit;
  text-decoration: none;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(184, 149, 106, 0.15);

  &:hover {
    background: linear-gradient(135deg, rgba(168, 146, 84, 0.18) 0%, rgba(184, 149, 106, 0.12) 100%);
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(184, 149, 106, 0.25);
    border-color: var(--primary-dark);
  }
`;

export const BannerIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: var(--primary-color);
  color: #fff;
  flex-shrink: 0;
  font-weight: 700;
`;

export const BannerBody = styled.div`
  flex: 1;
  min-width: 0;
`;

export const BannerTitle = styled.div`
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary);
  letter-spacing: -0.01em;
`;

export const BannerCaption = styled.div`
  font-size: 0.8125rem;
  font-weight: 500;
  color: var(--text-muted);
  margin-top: 3px;
  line-height: 1.4;
`;

export const BannerArrow = styled.span`
  color: var(--primary-color);
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  font-weight: 700;
`;

/* ---------- Quick actions (chip row) ---------- */

export const QuickRow = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.625rem;
  margin-bottom: 2.75rem;

  @media (max-width: 900px) { grid-template-columns: repeat(2, 1fr); }
  @media (max-width: 480px) { grid-template-columns: 1fr; }
`;

export const QuickChip = styled(Link)`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0.875rem 1.125rem;
  background: var(--background-primary);
  border: 1.5px solid var(--primary-color);
  border-radius: 10px;
  color: var(--primary-color);
  text-decoration: none;
  font-size: 0.9375rem;
  font-weight: 600;
  transition: all 0.2s ease;
  box-shadow: 0 2px 6px rgba(184, 149, 106, 0.1);

  &:hover {
    background: rgba(184, 149, 106, 0.08);
    border-color: var(--primary-dark);
    color: var(--primary-dark);
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(184, 149, 106, 0.2);
    transform: translateY(-1px);
  }
  &:active { transform: translateY(0); }
`;

export const QuickIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: rgba(184, 149, 106, 0.12);
  color: var(--primary-color);
  flex-shrink: 0;
`;

/* ---------- Manage grid ---------- */

